var t={btnWhats:"whatsapp-button-branding-style-module_btnWhats__Qx2Ig",small:"whatsapp-button-branding-style-module_small__aCg5T",outline:"whatsapp-button-branding-style-module_outline__MBUor"};export{t as default};
//# sourceMappingURL=whatsapp-button-branding.style.module.scss.js.map
